@if (spinnerObservable | async) {
  <div class="spinner-container">
    <app-loading-spinner class="center-spinner"></app-loading-spinner>
  </div>
}
<div class="bundles-list-view-wrapper">
  <div>
    <p class="bundles-list-title" data-cy="bundles-list-title-graphic">PERIODS</p>
    <app-period-type-info-chart [periodTypeInfoChartData]="periodTypeInfoChartData">
    </app-period-type-info-chart>
  </div>
  <div>
    <p class="bundles-list-title" data-cy="bundles-list-title-list">{{bundlesListTitle}}</p>
    <app-period-bundles-table [bundlesList]="bundlesList"
      (updatePeriodDetailValue)="updatePeriodDetail($event)"
    [isBundleView]="true"></app-period-bundles-table>
  </div>
</div>

